module.exports = __webpack_public_path__ + "static/media/btn-story-carousel-left.d4c01d98.svg";